(function () {
  'use strict';

  // Desktop right-edge "peek" mini-cart. Renders a compact list of cart items
  // while the full cart drawer is closed. Shows only when the cart holds more
  // than `data-cart-peek-min` items. Clicking the panel (outside the quantity
  // steppers) navigates to /cart; the steppers change line quantities in place.

  var peek, itemsEl, subtotalEl, countEl;
  var minItems = 2;
  var cartUrl = '/cart';
  var moneyFormat = (window.Shopify && Shopify.money_format) || '${{amount}}';

  // The decrease button shows a trash icon at quantity 1 and a minus otherwise.
  // Hoisted so the in-place patch and the full render use the same markup.
  var TRASH_ICON = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6"></path><path d="M10 11v6"></path><path d="M14 11v6"></path><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path></svg>';

  // Last cart the server confirmed, used to price optimistic updates.
  var lastCart = null;
  // Set only for the duration of a dispatch, so this file's own cart:updated
  // listener can tell "already patched" from "someone else changed the cart".
  var patchedCart = null;

  function $(sel, root) { return (root || document).querySelector(sel); }

  function init() {
    peek = document.querySelector('[data-cart-peek]');
    if (!peek) return;

    minItems = parseInt(peek.getAttribute('data-cart-peek-min'), 10) || 2;
    // Prefer the shop's real format - see the note on data-money-format in
    // snippets/cart-peek.liquid.
    var declaredFormat = peek.getAttribute('data-money-format');
    if (declaredFormat) moneyFormat = declaredFormat;
    itemsEl = $('[data-cart-peek-items]', peek);
    subtotalEl = $('[data-cart-peek-subtotal]', peek);
    countEl = $('[data-cart-peek-count]', peek);
    var cta = $('.cart-peek__cta', peek);
    if (cta) cartUrl = cta.getAttribute('href') || cartUrl;

    // Quantity steppers update the line in place; everything else on the panel
    // is a shortcut to the cart page.
    peek.addEventListener('click', function (e) {
      var dec = e.target.closest('[data-cart-peek-decrease]');
      var inc = e.target.closest('[data-cart-peek-increase]');
      if (dec || inc) {
        e.preventDefault();
        e.stopPropagation();
        var item = e.target.closest('[data-cart-peek-item]');
        if (!item) return;
        var line = parseInt(item.getAttribute('data-line'), 10);
        var qty = getQty(item);
        queueQty(item, line, inc ? qty + 1 : Math.max(0, qty - 1), dec || inc);
        return;
      }
      // Let real links (thumbnail, "Go to Cart") behave normally.
      if (e.target.closest('a')) return;
      // Bare areas of the panel still go to the cart page.
      window.location.href = cartUrl;
    });

    // Keep in sync with cart changes made anywhere else on the page.
    document.addEventListener('cart:updated', function (e) {
      // Already brought up to date in place by changeLine below.
      if (patchedCart && e && e.detail === patchedCart) return;
      if (e && e.detail) render(e.detail);
      else refresh();
    });

    // Hide while the full drawer is open; reveal again on close.
    var mo = new MutationObserver(syncVisibility);
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    syncVisibility();
  }

  function getQty(item) {
    var el = $('[data-cart-peek-qty-value]', item);
    var v = parseInt(el && el.textContent, 10);
    return isNaN(v) ? 0 : v;
  }

  function changeLine(line, qty) {
    if (!line) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Patch when we can; the listener above then skips its render. Dispatch
        // either way so the drawer and badge listeners stay in sync. render()
        // used to run here AND in that listener, rebuilding the list twice.
        if (patchPeek(cart)) patchedCart = cart;
        else render(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        patchedCart = null;
      })
      .catch(function () { clearSpinners(); });
  }

  // Updates only what a quantity change moves, leaving the row in place. Returns
  // false if the structure shifted, so the caller can fall back to a full render.
  function patchPeek(cart) {
    if (!cart || !cart.items) return false;
    lastCart = cart;
    var rows = itemsEl ? itemsEl.querySelectorAll('[data-cart-peek-item]') : [];
    if (!rows.length || rows.length !== cart.items.length) return false;

    var byKey = {};
    cart.items.forEach(function (it, i) { byKey[it.key] = { item: it, line: i + 1 }; });

    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var found = byKey[row.getAttribute('data-key')];
      if (!found) return false;
      row.setAttribute('data-line', String(found.line));
      row.setAttribute('data-unit-price', found.item.final_price);
      row.setAttribute('data-qty', found.item.quantity);
      applyRow(row, found.item.quantity, found.item.final_line_price);
    }

    if (peek) peek.setAttribute('data-total-price', cart.total_price);
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (countEl) {
      var n = cart.item_count || 0;
      countEl.textContent = n + ' item' + (n === 1 ? '' : 's');
    }
    clearSpinners();
    syncVisibility(cart.item_count);
    return true;
  }

  // One place that writes a row's quantity, price and decrease-button icon, so
  // the optimistic update and the server's answer cannot render it differently.
  function applyRow(row, qty, linePrice) {
    var val = $('[data-cart-peek-qty-value]', row);
    if (val) val.textContent = qty;
    var price = $('[data-cart-peek-item-price]', row);
    if (price && linePrice != null) price.textContent = formatMoney(linePrice);
    var decBtn = $('[data-cart-peek-decrease]', row);
    if (decBtn) {
      var wantTrash = qty <= 1;
      var hasTrash = !!decBtn.querySelector('svg');
      // Only touch it on an actual change: rewriting innerHTML every time would
      // restart the spinner's animation mid-spin.
      if (wantTrash !== hasTrash) decBtn.innerHTML = wantTrash ? TRASH_ICON : '&minus;';
    }
  }

  function clearSpinners() {
    if (!peek) return;
    var busy = peek.querySelectorAll('.cart-peek__qty-btn.is-loading');
    for (var i = 0; i < busy.length; i++) busy[i].classList.remove('is-loading');
  }

  // Presses used to fire a request each and show nothing until it returned. The
  // quantity, line price and subtotal now move on the press, and a burst
  // collapses into one call carrying the final quantity.
  var qtyTimer = null;
  var qtyPending = null;

  function flushQty() {
    if (qtyTimer) { clearTimeout(qtyTimer); qtyTimer = null; }
    if (!qtyPending) return;
    var p = qtyPending;
    qtyPending = null;
    changeLine(p.line, p.qty);
  }

  function queueQty(item, line, qty, btn) {
    // A different row while one is waiting: send that first, so two concurrent
    // change requests cannot race and let the loser's stale cart win.
    if (qtyPending && qtyPending.line !== line) flushQty();

    if (btn) btn.classList.add('is-loading');

    // Priced from the row's own attributes rather than a cached cart: the panel
    // is server-rendered, so on a fresh page there is no cart JSON yet and the
    // first press would leave the money behind. Liquid, render() and patchPeek
    // all keep these current.
    //
    // final_price is per unit, so the line total is unit x quantity. Exact for
    // ordinary pricing, briefly approximate where a discount is tiered by
    // quantity; patchPeek overwrites it with the server's figure either way.
    var unit = parseInt(item.getAttribute('data-unit-price'), 10);
    var serverQty = parseInt(item.getAttribute('data-qty'), 10);
    var total = peek ? parseInt(peek.getAttribute('data-total-price'), 10) : NaN;

    applyRow(item, qty, isNaN(unit) ? null : unit * qty);
    if (subtotalEl && !isNaN(unit) && !isNaN(serverQty) && !isNaN(total)) {
      subtotalEl.textContent = formatMoney(total + (qty - serverQty) * unit);
    }

    qtyPending = { line: line, qty: qty };
    if (qtyTimer) clearTimeout(qtyTimer);
    qtyTimer = setTimeout(flushQty, 300);
  }

  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  function render(cart) {
    if (!peek || !cart) return;
    lastCart = cart;

    if (peek) peek.setAttribute('data-total-price', cart.total_price);
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (countEl) {
      var n = cart.item_count || 0;
      countEl.textContent = n + ' item' + (n === 1 ? '' : 's');
    }

    if (itemsEl) {
      var html = '';
      (cart.items || []).forEach(function (item, i) {
        var image = item.image ? imageUrl(item.image, 120) : '';
        var isLast = item.quantity <= 1;
        var decIcon = isLast ? TRASH_ICON : '&minus;';
        html += '<li class="cart-peek__item" data-cart-peek-item data-line="' + (i + 1) + '" data-key="' + escapeAttr(item.key) + '"' +
          ' data-unit-price="' + item.final_price + '" data-qty="' + item.quantity + '">' +
          '<a class="cart-peek__item-img" href="' + escapeAttr(cartUrl) + '" aria-label="View cart — ' + escapeAttr(item.product_title || item.title || '') + '">' +
            (image ? '<img src="' + escapeAttr(image) + '" alt="' + escapeAttr(item.product_title || item.title || '') + '" loading="lazy" width="60" height="60">' : '') +
          '</a>' +
          '<span class="cart-peek__item-price" data-cart-peek-item-price>' + formatMoney(item.final_line_price) + '</span>' +
          '<div class="cart-peek__qty" data-cart-peek-qty>' +
            '<button type="button" class="cart-peek__qty-btn" data-cart-peek-decrease aria-label="Decrease quantity">' + decIcon + '</button>' +
            '<span class="cart-peek__qty-value" data-cart-peek-qty-value>' + item.quantity + '</span>' +
            '<button type="button" class="cart-peek__qty-btn" data-cart-peek-increase aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</li>';
      });
      itemsEl.innerHTML = html;
    }

    syncVisibility(cart.item_count);
  }

  // Show only when there are more than `minItems` items AND the full drawer is
  // closed. When item_count is omitted, count the rendered rows.
  function syncVisibility(itemCount) {
    if (!peek) return;
    if (typeof itemCount !== 'number') {
      var rows = itemsEl ? itemsEl.querySelectorAll('[data-cart-peek-item]') : [];
      itemCount = 0;
      for (var i = 0; i < rows.length; i++) {
        itemCount += getQty(rows[i]);
      }
    }
    var drawerOpen = document.body.classList.contains('cart-drawer-open');
    var show = itemCount >= minItems && !drawerOpen;
    if (show) peek.removeAttribute('hidden');
    else peek.setAttribute('hidden', '');
    // Reserve space on the right so the body shifts left instead of being
    // covered by the panel.
    document.body.classList.toggle('cart-peek-active', show);
  }

  function imageUrl(src, size) {
    if (!src) return '';
    var withProtocol = src.indexOf('//') === 0 ? 'https:' + src : src;
    return withProtocol.replace(/(\.(?:jpg|jpeg|png|gif|webp))(\?.*)?$/i, '_' + size + 'x$1$2');
  }

  function formatMoney(cents) {
    if (cents == null) return '';
    if (typeof window.Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    // Fallback path, and it has to honour the shop's format rather than assume
    // "$1.00". Shopify.formatMoney is not on every template - it is absent on
    // the Added to cart page - and this line hardcoding the symbol is what made
    // JS-drawn prices lose the space in this shop's "$ {{amount}}", and drop the
    // thousands separator the money filter applies.
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (/\{\{\s*amount\s*\}\}/.test(moneyFormat)) {
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
    }
    return '$' + amount;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
